import React from 'react';
import { Castle, Waves, Trophy, Gamepad2 } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Castle,
      title: "Castillos Inflables",
      description: "Castillos mágicos de todos los tamaños y temáticas para hacer volar la imaginación",
      color: "from-red-500 to-pink-500"
    },
    {
      icon: Waves,
      title: "Toboganes Gigantes",
      description: "Toboganes espectaculares que crean momentos inolvidables llenos de adrenalina",
      color: "from-blue-500 to-cyan-500"
    },
    {
      icon: Trophy,
      title: "Pistas de Obstáculos",
      description: "Desafíos emocionantes perfectos para competencias y trabajo en equipo",
      color: "from-yellow-500 to-orange-500"
    },
    {
      icon: Gamepad2,
      title: "Juegos Interactivos",
      description: "Zonas de juego completas con actividades múltiples para diversión sin límites",
      color: "from-purple-500 to-pink-500"
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos una amplia variedad de inflables premium para hacer de tu evento una experiencia única
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={index}
                className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
              >
                {/* Icon Container */}
                <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6 transform group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300`}>
                  <Icon className="w-8 h-8 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Effect Border */}
                <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            ¿No encuentras lo que buscas? Contáctanos y creamos una solución personalizada
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center px-8 py-4 bg-gray-900 text-white font-semibold rounded-xl hover:bg-gray-800 transition-colors duration-300 shadow-lg hover:shadow-xl"
          >
            Solicitar Cotización Personalizada
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
